import {NestedModel} from "../nestedmodel";
import {debug_error, debug_log} from "../../logger";
import differenceWith from "lodash/differenceWith";
import isEqual from "lodash/isEqual";
import has from "lodash/has";
import {Model} from "mobx-rest";


class _DataTableId extends Model {
    constructor(props, attributes) {
        super(props, {...attributes});
        this.value = props.value;
        this.data = props.data;
    }

    urlRoot() {
        return '/uxDataTableEditor';
    }

    url() {
        return [this.urlRoot(), this.value].join('/');
    }

    save() {
        return this.fetch({data: this.data, method: "POST"});
    }

}

export class DataTableId extends NestedModel {
    constructor(props, attributes) {
        super(props, {...attributes});
    }

    /*
     * Return Request (import {Request} from 'mobx-rest/lib/Request';)
     */
    save(attributes, options) {
        const data = this._buildPostData();
        debug_log('Saving DataTableId', data);

        const _dataTableId = new _DataTableId({value: this.value, data: data});
        let retPromise = _dataTableId.save().promise;
        retPromise
            .then(this._updateLocalDataWithResult)
            // .then(this.commitChanges.bind(this))
            .then(() => {
                this.commitChanges()
            })
            .catch(error => {
                debug_error(error);
                throw error;
            });
        return retPromise;
    }

    _updateLocalDataWithResult = (result) => {
        if (typeof result.data !== "undefined" && Array.isArray(result.data)) {
            this.get('data').replace(result.data);
        }
        return Promise.resolve(this.get('data'));
    }

    _buildPostData() {
        // Jsonifying to speed up the comparison.
        const original = JSON.parse(JSON.stringify(this.committedAttributes.get('data')));
        const changed = JSON.parse(JSON.stringify(this.get('data')));
        const changedAndAdded = differenceWith(changed, original, isEqual);
        const removedAndChanged = differenceWith(original, changed, isEqual);

        const added = changed.filter(obj => !has(obj, 'id'));
        const changedObjects = differenceWith(changedAndAdded, added);
        const missing = differenceWith(
            removedAndChanged,
            changedAndAdded,
            (a, b) => (a.id == b.id)
        );
        return {
            addRowObjects: added,
            updateRowObjects: changedObjects,
            deleteRowObjects: missing,
        };
    }

}
